import { LIGHT_THEME_NEUTRALS, DARK_THEME_NEUTRALS } from 'owa-theme-common';

export default function getNeutralPaletteAsRawColors(
    isDarkTheme: boolean
): Record<keyof typeof LIGHT_THEME_NEUTRALS, string> {
    return isDarkTheme ? DARK_THEME_NEUTRALS : LIGHT_THEME_NEUTRALS;
}
